import { render, staticRenderFns } from "./Adventure.vue?vue&type=template&id=bd6d218e&scoped=true&"
import script from "./Adventure.vue?vue&type=script&lang=js&"
export * from "./Adventure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6d218e",
  null
  
)

export default component.exports